import { O } from "../../../features/ui";
import { MeasureType } from "../../common";
import { UnitType, UnitTypeCategory, UnitTypeName } from "../../stock";
import { MeasureLabel } from "../state/types";

export const getUnitTypeCategory = (measureType: MeasureType): O<UnitTypeCategory> => {
    const categories = new Map<MeasureType, UnitTypeCategory>()
        .set(MeasureType.AREA, UnitTypeCategory.AREA)
        .set(MeasureType.DEPTH, UnitTypeCategory.LENGTH)
        .set(MeasureType.DIAMETER, UnitTypeCategory.LENGTH)
        .set(MeasureType.HEIGHT, UnitTypeCategory.LENGTH)
        .set(MeasureType.LENGTH, UnitTypeCategory.LENGTH)
        .set(MeasureType.PACKAGE_UNITS, UnitTypeCategory.BASIC)
        .set(MeasureType.THICKNESS, UnitTypeCategory.LENGTH)
        .set(MeasureType.VOLUME, UnitTypeCategory.VOLUME)
        .set(MeasureType.WEIGHT, UnitTypeCategory.WEIGHT)
        .set(MeasureType.WIDTH, UnitTypeCategory.LENGTH)
    return categories.get(measureType)
}

export const sortUnitTypes = (unitType_A: UnitType, unitType_B: UnitType) => {
    const priorities = new Map<string, number>()
        .set(UnitTypeName.UNIT, 1)
        .set(UnitTypeName.METER, 2)
        .set(UnitTypeName.CENTIMETER, 3)
        .set(UnitTypeName.MILLIMETER, 4)
        .set(UnitTypeName.KILOGRAM, 5)
        .set(UnitTypeName.GRAM, 6)
        .set(UnitTypeName.MILLIGRAM, 7)
        .set(UnitTypeName.TON, 8)
        .set(UnitTypeName.SQUARE_METER, 9)
        .set(UnitTypeName.SQUARE_CENTIMETER, 10)
        .set(UnitTypeName.LITER, 11)
        .set(UnitTypeName.MILLILITER, 12)
        .set(UnitTypeName.CUBIC_METER, 13)
    const order = (priorities.get(unitType_A.name) || 14) - (priorities.get(unitType_B.name) || 14)
    return order !== 0 ? order : unitType_A.name.localeCompare(unitType_B.name)
}

export const getMeasureLabel = (measureLabel: MeasureLabel, plural = false) => {
    const labels = new Map<MeasureLabel, [string, string]>()
        .set(MeasureLabel.UNITS, ['u', 'u'])
        .set(MeasureLabel.BOX, ['caja', 'cajas'])
        .set(MeasureLabel.DRAWER, ['cajón', 'cajones'])
        .set(MeasureLabel.BUCKET, ['balde', 'baldes'])
        .set(MeasureLabel.BOTTLE, ['bidón', 'bidones'])
        .set(MeasureLabel.BAG, ['bolsa', 'bolsas'])
        .set(MeasureLabel.BIG_BAG, ['bolsón', 'bolsones'])
        .set(MeasureLabel.DOYPACK, ['doypack', 'doypacks'])
        .set(MeasureLabel.PALLET, ['pallet', 'pallets'])
        .set(MeasureLabel.CAN, ['lata', 'latas'])
        .set(MeasureLabel.MESH, ['malla', 'mallas'])
        .set(MeasureLabel.SACHET, ['sachet', 'sachets'])
        .set(MeasureLabel.DRUM, ['tambor', 'tambores'])
    return labels.get(measureLabel)![plural ? 1 : 0]
}
